// extracted by mini-css-extract-plugin
export var animationContainer = "_ow-0";
export var footer = "_ow-1";
export var gray = "_ow-2";
export var lineItem = "_ow-3";
export var lineItemImage = "_ow-4";
export var lineItemInfo = "_ow-5";
export var lineItemText = "_ow-6";
export var lineItems = "_ow-7";
export var modalContent = "_ow-8";
export var options = "_ow-9";
export var orderName = "_ow-a";
export var refundAmount = "_ow-b";